var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrop = function SvgDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 11.7646C10.1667 12.9581 9.69264 14.1027 8.84873 14.9466C8.00481 15.7905 6.86022 16.2646 5.66675 16.2646C4.47327 16.2646 3.32868 15.7905 2.48477 14.9466C1.64085 14.1027 1.16675 12.9581 1.16675 11.7646C1.16675 8.51792 4.13208 3.62326 5.24808 1.89792C5.29297 1.82759 5.35486 1.76969 5.42803 1.72959C5.50121 1.68948 5.58331 1.66846 5.66675 1.66846C5.75019 1.66846 5.83229 1.68948 5.90546 1.72959C5.97863 1.76969 6.04052 1.82759 6.08542 1.89792C7.20142 3.62326 10.1667 8.51792 10.1667 11.7646Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 14.2666C5.33828 14.2666 5.01302 14.2019 4.70958 14.0762C4.40613 13.9504 4.13045 13.7661 3.89827 13.5337C3.6661 13.3014 3.482 13.0255 3.35648 12.722C3.23096 12.4184 3.16649 12.0931 3.16675 11.7646",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDrop;